import { createGlobalStyle } from 'styled-components';
import breakpoints from './breakpoints';

const { laptop, tablet, mobileWider } = breakpoints;

export default createGlobalStyle`
  * {
    margin: 0;
    padding: 0;
    box-sizing: border-box;
    font-size: 1rem;
    font-family: -apple-system, BlinkMacSystemFont, 'Segoe UI', Roboto, Oxygen, Ubuntu, Cantarell, 'Open Sans', 'Helvetica Neue', sans-serif;
    
    @media (max-width: ${laptop}px) {
      font-size: 0.8rem;
    }

    @media (max-width: ${tablet}px) {
      font-size: 0.6rem;
    }

    @media (max-width: ${mobileWider}px) {
      font-size: 0.5rem;
    }
  }

  body {
    display: flex;
    flex-direction: column;
    flex: 1;
    overflow-x: hidden;
  }
  
  a {
    text-decoration: none;

    &:hover {
      cursor: pointer;
    }
  }


  button,
  input,
  select {
    border: none;
    outline: none;
  }

  button,
  select {
    &:hover {
      cursor: pointer;
    }
  }

  div,
  h1,
  h2,
  h3,
  h4,
  h5,
  h6 {
    transition-duration: 1s;
  }
`;
